// The domain part of an email address, used to tell company sign-ups from
// personal ones without sending the address itself to analytics.
export const emailDomain = (email: string) =>
  email.split("@").pop()?.trim().toLowerCase() ?? ""
